import { TherapistAPI, type Therapist } from "../../therapist";

/** Save changes to the therapist's own profile and return the stored therapist. */
export async function updateTherapistProfile(id: string, changes: Partial<Therapist>): Promise<Therapist> {
    const { data } = await TherapistAPI.update(id, changes);
    return data;
}

/** Delete the therapist's account. */
export async function deleteTherapistAccount(id: string): Promise<void> {
    await TherapistAPI.delete(id);
}
